import { testimonials } from "@/mocks/kakobuy";

export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-5 h-5 flex items-center justify-center text-accent-500">
              <i className="ri-star-fill text-xs"></i>
            </span>
            <span className="text-xs md:text-sm text-accent-600 font-medium tracking-wide uppercase">
              Opinie Użytkowników
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900">
            Co Mówią o{" "}
            <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.name}
              className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center overflow-hidden">
                  <span className="text-accent-600 font-semibold text-sm">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="mb-4">
                <span className="w-7 h-7 flex items-center justify-center text-primary-400">
                  <i className="ri-double-quotes-l text-xl"></i>
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          <div className="relative rounded-2xl overflow-hidden h-[220px] group">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20customer%20unboxing%20a%20package%20with%20genuine%20joy%20surrounded%20by%20shopping%20bags%20and%20fashion%20products%20in%20a%20bright%20modern%20living%20room%20authentic%20lifestyle%20moment%20captured%20with%20natural%20window%20light%20warm%20genuine%20emotion%20real%20person%20vibe&width=800&height=440&seq=testimonial-img-v2-2026-jun&orientation=landscape"
              alt="Kakobuy Spreadsheet - zadowolona klientka z zakupami"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-white text-sm font-medium">{testimonials[3].name}</p>
              <p className="text-white/70 text-xs">{testimonials[3].role}</p>
              <p className="text-white/90 text-xs mt-2 leading-relaxed max-w-md">{testimonials[3].text}</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="mb-3">
              <span className="w-7 h-7 flex items-center justify-center text-primary-400">
                <i className="ri-double-quotes-l text-xl"></i>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              {testimonials[4].text}
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-accent-600 font-semibold text-sm">
                  {testimonials[4].name.charAt(0)}
                </span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">{testimonials[4].name}</p>
                <p className="text-xs text-foreground-500">{testimonials[4].role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}